<template>
  <div class="right-chart-1">
    <div class="lc1-header">线下咨询服务</div>

    <div id="offline" style="height: 100%; width: 100%;"></div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LayoutRight',
    data() {
        return {
            config: {
            },
            mapChart: null,
            mapOtion: null,
        }
    },
    mounted() {
        this.initMapChart()
        this.loadList()
    },
    methods: {
        loadList() {
            var that = this;
            axios.get(this.$store.state.config.host + "/big/service/").then(response => {
                var list = [], city = []
                Object.values(response.data.data).forEach(element => {
                    list.push({
                        name: element.city_text,
                        city: element.city,
                        value: element.scene
                    })
                    city.push(element.city_text)

                });
                that.mapOption.legend.data = city
                that.mapOption.series[0].data = list
                that.mapChart.setOption(that.mapOption)
            })
        },
        initMapChart() {
            if (!this.mapChart) {
                this.mapChart = this.$echarts.init(document.getElementById('offline'))
            }
            this.mapOption = {
                // title: {
                    // text: '同名数量统计',
                    // subtext: '纯属虚构',
                    // left: 'center'
                // },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: 10,
                    top: 20,
                    bottom: 20,
                    data: null
                },
                series: [
                    {
                        name: '城市',
                        type: 'pie',
                        radius: '55%',
                        center: ['40%', '50%'],
                        data: null,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
        }
    }
}
</script>

<style lang="less">
.right-chart-1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;

  .lc1-header {
    text-align: center;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    margin-bottom: 20px;
  }

  }

  .right-chart {
    flex: 1;
  }
</style>

